export default __webpack_public_path__ + "static/media/DNo.5-0.9b40b137.jpg";